'use strict';
const _ = require('underscore');
module.exports = function atlasResultWrapper(decorators, atlasModel) {
	const initialResultProcessing = function (result) {
		if (result.atlasUrl) {
			atlasModel.storePublishingResult(result.export);
			result['index-html'] = result['index-html'] || result.atlasUrl + '/index.html';
			result['archive-zip'] = result['archive-zip'] || result.atlasUrl + '/archive.zip';
			result['thumb-png'] = result['thumb-png'] || result.atlasUrl + '/thumb.png';
		}
		return result;
	};
	return [initialResultProcessing].concat(_.values(decorators));
};
